import { render, staticRenderFns } from "./AddQualification.vue?vue&type=template&id=3dcc83b5&scoped=true"
import script from "./AddQualification.vue?vue&type=script&lang=js"
export * from "./AddQualification.vue?vue&type=script&lang=js"
import style0 from "./AddQualification.vue?vue&type=style&index=0&id=3dcc83b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcc83b5",
  null
  
)

export default component.exports